interface IProps {
    color?: string;
    size?: number;
    bg_color?: string;
}

export const IconCard = (props: IProps) => {
    const { color = "#CE0000", size, bg_color } = props;

    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3109_109142)">
                <path d="M0 11.045V17.2562C0 19.0448 1.44995 20.4948 3.23859 20.4948H20.7614C22.5501 20.4948 24 19.0448 24 17.2562V11.045C24 10.7339 23.7478 10.4818 23.4368 10.4818H0.563233C0.252187 10.4818 0 10.7339 0 11.045ZM5.99219 14.9876H4.49023C3.94587 14.9876 3.50457 14.5463 3.50457 14.002C3.50457 13.4576 3.94587 13.0163 4.49023 13.0163H5.99219C6.53655 13.0163 6.97784 13.4576 6.97784 14.002C6.97784 14.5463 6.53655 14.9876 5.99219 14.9876Z" fill="white" />
                <path d="M24 7.94721V7.74384C24 5.9552 22.5501 4.50525 20.7614 4.50525H3.23859C1.44995 4.50525 0 5.9552 0 7.74384V7.94721C0 8.25826 0.252187 8.51044 0.563233 8.51044H23.4368C23.7478 8.51044 24 8.25826 24 7.94721Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_3109_109142">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>

    );
};